import { goals } from '~api';
import { ConsecutiveDays } from '~models';
import { DailyActivity } from '~models';
import { getField, updateField } from 'vuex-map-fields';
import { Handler } from '~services';
import router from '~router';

const RESET_GOAL = 'RESET_GOAL';
const SET_GOAL_PARAM = 'SET_GOAL_PARAM';

const LOADING = 'LOADING';

const DAILY_ACTIVITY = 'view_page_events_in_period';
const state = {
    consecutiveDays: { ...new ConsecutiveDays() },
    dailyActivity: { ...new DailyActivity() },
    isLoading: false
};

const actions = {
    /**
     * Reset goals state and redirect to business list
     * @param {function} commit
     */
    cancel({ commit }) {
        router.push({ name: 'dashboard.businesses' });
        commit(RESET_GOAL, 'consecutiveDays');
    },
    /**
     * Reset goal state
     * @param {function} commit
     */
    resetGoal({ commit }, goal) {
        commit(RESET_GOAL, goal);
    },

    /**
     * Create Business account goals
     * @param {function} commit
     * @param  {string} id
     */
    async createGoals({ commit, dispatch, state }, id) {
        const localGoals = { goals: [] };
        const { consecutiveDays, dailyActivity } = state;
        const successMessage = 'Goals updated';
        commit(LOADING);

        if (consecutiveDays.isActive) {
            Object.keys(consecutiveDays.params).map(key => {
                if (consecutiveDays.params[key]) {
                    const param = {
                        goal: key
                    };
                    localGoals.goals.push(param);
                }
            });
        }

        if (dailyActivity.isActive) {
            localGoals.goals.push({ goal: DAILY_ACTIVITY });
        }

        // Api request get business account by id
        const resp = await goals.createGoals(id, localGoals);

        if (resp.ok) {
            dispatch('cancel');
        }

        Handler.handleResponse(resp, successMessage);

        commit(LOADING);
    },

    /**
     * Get Business account goals
     * @param {function} commit
     * @param  {string} id
     */
    async readGoals({ commit }, id) {
        commit(LOADING);

        // Api request get business account by id
        const resp = await goals.readGoals(id);

        if (resp.ok) {
            const consecutiveDaysKey = Object.keys(
                state.consecutiveDays.params
            );

            resp.data.map(item => {
                if (item.goal === DAILY_ACTIVITY) {
                    commit('SET_GOAL_PARAM', {
                        goal: 'dailyActivity',
                        hasParams: false
                    });
                }
                if (consecutiveDaysKey.includes(item.goal)) {
                    commit('SET_GOAL_PARAM', {
                        goal: 'consecutiveDays',
                        hasParams: true,
                        param: item.goal
                    });
                }
            });
        } else {
            // Handle response if error
            Handler.handleResponse(resp);
        }

        commit(LOADING);
    }
};

const mutations = {
    // Add the `updateField` mutation to the
    // `mutations` of your Vuex store instance.
    updateField,
    [LOADING](state) {
        state.isLoading = !state.isLoading;
    },
    [RESET_GOAL](state, goal) {
        switch (goal) {
            case 'consecutiveDays':
                state.consecutiveDays = { ...new ConsecutiveDays() };
                break;

            case 'dailyActivity':
                state.dailyActivity = true;
                break;

            default:
                break;
        }
    },
    [SET_GOAL_PARAM](state, data) {
        const { goal, param, hasParams } = data;

        state[goal].isActive = true;
        if (hasParams) state[goal].params[param] = true;
    }
};

const getters = {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
    isLoading: state => state.isLoading
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
